import { TabView } from '@/features/app-tabs/tab-view';

/** Services landing tab — reference consumer of GET /user/services. */
export function ServicesTabPage() {
  return <TabView tab="services" title="Services" />;
}
